<template>
  <v-dialog v-model="dialog" persistent width="400px" @keydown.esc="onDialogClose">
    <v-row no-gutters>
      <v-snackbar
        v-model="showSnackbar"
        :color="snackbarColor"
        :timeout="snackbarTimeout"
        :top="true"
      >
        {{ snackbarMsg }}
        <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
      </v-snackbar>
      <v-col>
        <v-card flat color="white">
          <v-card-title dark class="dialog-header-title"
            >Notify for container pull back</v-card-title
          >
          <v-card-text v-if="shipment != null">
            <v-row class="d-flex justify-center">
              <v-col cols="7">
                <span>When:</span>
                <flat-pickr
                  v-model="shipment.notify_pull_back_ready.when"
                  class="form-control"
                  style="background: white"
                  placeholder="Select date"
                  name="date"
                ></flat-pickr>
              </v-col>
              <v-col cols="4" class="d-flex justify-end">
                <v-btn
                  @click="onSave(shipment.notify_pull_back_ready)"
                  class="font-weight-bold mr-2 mt-5"
                  color="primary"
                  outlined
                  >NOTIFY</v-btn
                >
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row justify="end">
              <v-btn
                @click="onDialogClose"
                class="font-weight-bold"
                color="error"
                tile
                depressed
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import constant from "../../const";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";

export default {
  props: ["dialog", "value"],
  components: {
    flatPickr,
  },

  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      shipment: null,
      ObjUpdated: false,
    };
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.ObjUpdated = false;
        this.shipment = this.value;
      } else {
        this.shipment = null;
      }
    },
  },

  methods: {
    /**
     * Save notify pull back ready
     */
    onSave(postform) {
      this.$root.blockUImsg = "Saving..";
      this.$root.blockUIshow = true;

      this.$https
        .put(
          `/api/shipment_orders/${this.shipment.shipment_order_id}/notify_pull_back`,
          postform
        )
        .then((resp) => {
          if (resp.data.status == constant.RESPONSE_STATUS_OK) {
            this.showSnackbar = true;
            this.snackbarColor = "success";
            this.snackbarMsg = resp.data.msg;
            this.$root.blockUIshow = false;
            this.ObjUpdated = true;

            // close the dialog after 2 seconds
            setTimeout(() => {
              this.onDialogClose();
            }, 1500);
          } else {
            this.$root.blockUIshow = false;
            this.showSnackbar = true;
            this.snackbarColor = "error";
            this.snackbarMsg = resp.data.msg;
          }
        })
        .catch((err) => {
          this.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = err;
        });
    },

    onDialogClose() {
      this.$emit(
        "dialog-close",
        constant.DIALOG_NOTIFY_PULL_BACK_READY,
        this.shipment,
        this.ObjUpdated
      );
    },
  },

  computed: {},
};
</script>

<style></style>
